import "./header.scss";
import { NavLink } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { useState } from "react";
import Registration from "../Modals/Registration/index";
import SignIn from "../Modals/SignIn/index";
import CheckPhone from "../Modals/CheckPhone/index";
import RegistrationSuccessModal from "../Modals/RegistrationSuccessModal/index";
import NewPassword from "../Modals/NewPassword/index";
import SignInWithNewPassword from "../Modals/SignInWithNewPassword/index";

import ChooseVacancyModal from "../Modals/ChooseVacancyModal/index";
import ChooseCenterDate from "../Modals/ChooseCenterDate/index";
import ApplicationSuccessModal from "../Modals/ApplicationSuccessModal/index";
import SendApplicationModal from "../Modals/SendApplicationModal/index";
import DeleteCandidateModal from "../Modals/DeleteCandidateModal/index";
import CandidateForm from "sharedComponents/CandidateForm";

import bigLogo from "./images/bigLogo.svg";
import burger from "./images/burger.svg";
import menucross from "./images/menucross.svg";

const Header = ({
  token,
  logoutUser,
  changeToken,
  cleanErrorRegistration,
  setRegistrationModal,
  setSignInModal,
  setSuccessModal,
  setNewPasswordModal,
  registrationModal,
  signInModal,
  checkPhoneModal,
  setCheckPhoneModal,
  successModal,
  newPasswordModal,
  setSignInWithNewPasswordModal,
  signInWithNewPasswordModal,
  modalShowVacancies,
  modalShowCenterDate,
  setModalShowCenterDate,
  setModalShowVacancies,
  setSendApplicationModal,
  sendApplicationModal,
  applicationSuccessModal,
  setApplicationSuccessModal,
  deleteCandidateModal,
  setDeleteCandidateModal,

  setSelectedCandidate,
  setSelectedVacancy,
  setSelectedCenter,
  setSelectedDate,
  setUpdateVacancyCandidateId,
  cleanErrorWithoutDate,

  isCandidateModalOpen,
  setIsCandidateModalOpen
}) => {
  const [openBurgerMenu, setOpenBurgerMenu] = useState(false);

  const openMenu = () => {
    if (openBurgerMenu) {
      setOpenBurgerMenu(false);
      document.body.setAttribute("style", "");
    } else {
      setOpenBurgerMenu(true);
      document.body.style.overflow = "hidden";
    }
  };

  return (
    <>
      <div className="header-menu">
        <div>
          <div className="header-menu-container">
            <NavLink to="/allvacancies" className="header-menu-logo">
              <img src={bigLogo} alt="" />
            </NavLink>
            <img
              src={openBurgerMenu ? menucross : burger}
              className="header-menu-burger"
              onClick={() => openMenu()}
              alt=""
            />
          </div>
          <div
            className={`header-menu-big ${openBurgerMenu ? "header-menu-open" : ""
              }`}
          >
            <div className="nav-items">
              <a
                href="https://invite.polati.ru/"
                className="menu-buttonlink"
              >
                Главная
              </a>
              <NavLink
                to="/aboutus"
                onClick={() => {
                  setOpenBurgerMenu(false);
                  document.body.setAttribute("style", "");
                }}
                className={({ isActive }) =>
                  "menu-buttonlink " + (isActive ? "active-menu-link" : "")
                }
              >
                О нас
              </NavLink>
              <NavLink
                to="/allnews"
                onClick={() => {
                  setOpenBurgerMenu(false);
                  document.body.setAttribute("style", "");
                }}
                className={({ isActive }) =>
                  "menu-buttonlink " + (isActive ? "active-menu-link" : "")
                }
              >
                Новости
              </NavLink>
              <NavLink
                to="/allvacancies"
                onClick={() => {
                  setOpenBurgerMenu(false);
                  document.body.setAttribute("style", "");
                }}
                className={({ isActive }) =>
                  "menu-buttonlink " + (isActive ? "active-menu-link" : "")
                }
              >
                Наши офферы
              </NavLink>
            </div>
            {token ? (
              <div className="nav-items">
                <NavLink
                  to="/mycandidates"
                  onClick={() => {
                    setOpenBurgerMenu(false);
                    document.body.setAttribute("style", "");
                  }}
                  className={({ isActive }) =>
                    "menu-buttonlink " + (isActive ? "active-menu-link" : "")
                  }
                >
                  Мои кандидаты
                </NavLink>
                <NavLink
                  to="/myprofile"
                  onClick={() => {
                    setOpenBurgerMenu(false);
                    document.body.setAttribute("style", "");
                  }}
                  className={({ isActive }) =>
                    "menu-buttonlink " + (isActive ? "active-menu-link" : "")
                  }
                >
                  Мой профиль
                </NavLink>
                <p
                  onClick={async () => {
                    setOpenBurgerMenu(false);
                    document.body.setAttribute("style", "");
                    await logoutUser();
                    changeToken("");
                    setCheckPhoneModal(false);
                  }}
                  className="menu-link"
                >
                  Выйти
                </p>
              </div>
            ) : (
              <div className="nav-items-off">
                <p
                  onClick={() => {
                    setOpenBurgerMenu(false);
                    document.body.setAttribute("style", "");
                    setRegistrationModal(true);
                    setSignInModal(false);
                    cleanErrorRegistration();
                  }}
                  className="menu-link"
                >
                  Зарегистрироваться
                </p>

                <p
                  onClick={() => {
                    setOpenBurgerMenu(false);
                    document.body.setAttribute("style", "");
                    setSignInModal(true);
                    setRegistrationModal(false);
                    cleanErrorRegistration();
                  }}
                  className="menu-link"
                >
                  Войти
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <Registration
        show={registrationModal}
        onHide={() => setRegistrationModal(false)}
      />
      <SignIn show={signInModal} onHide={() => setSignInModal(false)} />
      <CheckPhone
        show={checkPhoneModal}
        onHide={() => setCheckPhoneModal(false)}
      />
      <RegistrationSuccessModal
        show={successModal}
        onHide={() => setSuccessModal(false)}
      />
      <NewPassword
        show={newPasswordModal}
        onHide={() => setNewPasswordModal(false)}
      />
      <SignInWithNewPassword
        show={signInWithNewPasswordModal}
        onHide={() => setSignInWithNewPasswordModal(false)}
      />

      <ChooseVacancyModal
        show={modalShowVacancies}
        onHide={() => setModalShowVacancies(false)}
      />
      <ChooseCenterDate
        show={modalShowCenterDate}
        onHide={() => {
          setModalShowCenterDate(false);
          setSelectedCandidate("");
          setSelectedVacancy("");
          setSelectedCenter("");
          setSelectedDate("");
          setUpdateVacancyCandidateId("");
        }}
      />
      <ApplicationSuccessModal
        show={applicationSuccessModal}
        onHide={() => {
          setApplicationSuccessModal(false);
          cleanErrorWithoutDate("");
        }}
      />
      <SendApplicationModal
        show={sendApplicationModal}
        onHide={() => {
          setSendApplicationModal(false);
          setSelectedCandidate("");
          setSelectedVacancy("");
          setSelectedCenter("");
          setSelectedDate("");
          setUpdateVacancyCandidateId("");
        }}
      />
      <DeleteCandidateModal
        show={deleteCandidateModal}
        onHide={() => setDeleteCandidateModal}
      />
      <CandidateForm
        show={isCandidateModalOpen}
        onHide={() => setIsCandidateModalOpen(false)}
      />
    </>
  );
};

export default inject(({ usersStore, modalWindows, candidatesStore }) => {
  const { token, changeToken, cleanErrorRegistration, logoutUser } = usersStore;

  const {
    setRegistrationModal,
    setSignInModal,
    setSuccessModal,
    setNewPasswordModal,
    guestModal,
    registrationModal,
    signInModal,
    checkPhoneModal,
    setCheckPhoneModal,
    successModal,
    newPasswordModal,

    setSignInWithNewPasswordModal,
    signInWithNewPasswordModal,

    modalShowVacancies,
    modalShowCenterDate,
    setModalShowCenterDate,
    setModalShowVacancies,
    setSendApplicationModal,
    sendApplicationModal,
    applicationSuccessModal,
    setApplicationSuccessModal,
    deleteCandidateModal,
    setDeleteCandidateModal,

    modalShowCandidate,
    setModalShowCandidate,

    isCandidateModalOpen,
    setIsCandidateModalOpen
  } = modalWindows;

  const {
    setSelectedCandidate,
    setSelectedVacancy,
    setSelectedCenter,
    setSelectedDate,
    setUpdateVacancyCandidateId,
    cleanErrorWithoutDate
  } = candidatesStore;

  return {
    token,
    logoutUser,
    changeToken,
    cleanErrorRegistration,
    setRegistrationModal,
    setSignInModal,
    setSuccessModal,
    setNewPasswordModal,
    guestModal,
    registrationModal,
    signInModal,
    checkPhoneModal,
    setCheckPhoneModal,
    successModal,
    newPasswordModal,
    setSignInWithNewPasswordModal,
    signInWithNewPasswordModal,
    modalShowVacancies,
    modalShowCenterDate,
    setModalShowCenterDate,
    setModalShowVacancies,
    setSendApplicationModal,
    sendApplicationModal,
    applicationSuccessModal,
    setApplicationSuccessModal,
    deleteCandidateModal,
    setDeleteCandidateModal,

    setSelectedCandidate,
    setSelectedVacancy,
    setSelectedCenter,
    setSelectedDate,
    setUpdateVacancyCandidateId,
    cleanErrorWithoutDate,

    modalShowCandidate,
    setModalShowCandidate,
    isCandidateModalOpen,
    setIsCandidateModalOpen
  };
})(observer(Header));
